import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask'
import { RouterModule, Routes } from '@angular/router';
import { WebStorageModule } from 'ngx-store';
import { registerLocaleData, HashLocationStrategy, LocationStrategy } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
library.add(fas);

import { FilterPipe } from './pipes/filter.pipe';
import { FiltroMultaPipe } from './pipes/filtro-multa.pipe';

import { AuthGuard } from './guard/auth.guard';
import { AdminGuard } from './guard/admin.guard';
import { CondutorGuard } from './guard/condutor.guard';
import { MecanicoGuard } from './guard/mecanico.guard';
import { TopBarComponent } from './top-bar/top-bar.component';
import { MenuLateralComponent } from './menu-lateral/menu-lateral.component';
import { FooterComponent } from './footer/footer.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './interceptors/token.interceptor';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { PaginationComponent } from './pagination/pagination.component';
import { UsuariosEditComponent } from './usuarios-edit/usuarios-edit.component';
import { MultasComponent } from './multas/multas.component';
import { MultasEditComponent } from './multas-edit/multas-edit.component';
import { DespesasComponent } from './despesas/despesas.component';
import { DespesasEditComponent } from './despesas-edit/despesas-edit.component';
import { TiposMultaComponent } from './tipos-multa/tipos-multa.component';
import { TiposMultaEditComponent } from './tipos-multa-edit/tipos-multa-edit.component';
import { TiposDespesaEditComponent } from './tipos-despesa-edit/tipos-despesa-edit.component';
import { TiposDespesaComponent } from './tipos-despesa/tipos-despesa.component';
import { GruposDespesaComponent } from './grupos-despesa/grupos-despesa.component';
import { GruposDespesaEditComponent } from './grupos-despesa-edit/grupos-despesa-edit.component';
import { UnidadesMedidaComponent } from './unidades-medida/unidades-medida.component';
import { UnidadesMedidaEditComponent } from './unidades-medida-edit/unidades-medida-edit.component';
import { DespesaPlanejamentosComponent } from './despesa-planejamentos/despesa-planejamentos.component';
import { DespesaPlanejamentosEditComponent } from './despesa-planejamentos-edit/despesa-planejamentos-edit.component';
import { VeiculosComponent } from './veiculos/veiculos.component';
import { VeiculosEditComponent } from './veiculos-edit/veiculos-edit.component';
import { TipoVeiculoComponent } from './tipo-veiculo/tipo-veiculo.component';
import { TipoVeiculoEditComponent } from './tipo-veiculo-edit/tipo-veiculo-edit.component';
import { EspecialidadeVeiculoComponent } from './especialidade-veiculo/especialidade-veiculo.component';
import { EspecialidadeVeiculoEditComponent } from './especialidade-veiculo-edit/especialidade-veiculo-edit.component';
import { MarcaVeiculoComponent } from './marca-veiculo/marca-veiculo.component';
import { MarcaVeiculoEditComponent } from './marca-veiculo-edit/marca-veiculo-edit.component';
import { ModeloVeiculoComponent } from './modelo-veiculo/modelo-veiculo.component';
import { ModeloVeiculoEditComponent } from './modelo-veiculo-edit/modelo-veiculo-edit.component';
import { ManutencaoComponent } from './manutencao/manutencao.component';
import { ManutencaoEditComponent } from './manutencao-edit/manutencao-edit.component';
import { CombustivelComponent } from './combustivel/combustivel.component';
import { CombustivelEditComponent } from './combustivel-edit/combustivel-edit.component';
import { IpvaComponent } from './ipva/ipva.component';
import { IpvaEditComponent } from './ipva-edit/ipva-edit.component';
import { SeguroComponent } from './seguro/seguro.component';
import { SeguroEditComponent } from './seguro-edit/seguro-edit.component';
import { MotivosIndisponibilidadeComponent } from './motivos-indisponibilidade/motivos-indisponibilidade.component';
import { MotivosIndisponibilidadeEditComponent } from './motivos-indisponibilidade-edit/motivos-indisponibilidade-edit.component';
import { AlertasComponent } from './alertas/alertas.component';
import { CoresVeiculoComponent } from './cores-veiculo/cores-veiculo.component';
import { CoresVeiculoEditComponent } from './cores-veiculo-edit/cores-veiculo-edit.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { ChecklistEditComponent } from './checklist-edit/checklist-edit.component';
import { DashboardFrotasComponent } from './dashboard-frotas/dashboard-frotas.component';
import { DashboardOperacaoComponent } from './dashboard-operacao/dashboard-operacao.component';
import { ModeloVeiculoManutencaoComponent } from './modelo-veiculo-manutencao/modelo-veiculo-manutencao.component';
import { IntervencoesComponent } from './intervencoes/intervencoes.component';
import { PostoComponent } from './posto/posto.component';
import { PostoEditComponent } from './posto-edit/posto-edit.component';
import { CategoriasDesepesaComponent } from './categorias-desepesa/categorias-desepesa.component';
import { CategoriasDesepesaEditComponent } from './categorias-desepesa-edit/categorias-desepesa-edit.component';
import { FiltroManutencoesPipe } from './pipes/filtro-manutencoes.pipe';
import { FiltroChecklistPipe } from './pipes/filtro-checklist.pipe';
import { FiltroPipe } from './pipes/filtro.pipe';
import { ProfissionaisComponent } from './profissionais/profissionais.component';
import { ProfissionaisEditComponent } from './profissionais-edit/profissionais-edit.component';
import { IntervencoesVeiculoComponent } from './intervencoes-veiculo/intervencoes-veiculo.component';
import { UsuarioEmailComponent } from './usuario-email/usuario-email.component';
import { RankingCondutoresComponent } from './ranking-condutores/ranking-condutores.component';
import { TelefonePipe } from './pipes/telefone.pipe';
import { CepPipe } from './pipes/cep.pipe';
import { EstoqueComponent } from './estoque/estoque.component';
import { EstoqueEditComponent } from './estoque-edit/estoque-edit.component';
import { ProdutoEntradaComponent } from './produto-entrada/produto-entrada.component';
import { ProdutoSaidaComponent } from './produto-saida/produto-saida.component';
import { GruposProdutoComponent } from './grupos-produto/grupos-produto.component';
import { GruposProdutoEditComponent } from './grupos-produto-edit/grupos-produto-edit.component';
import { PerfilUsuarioComponent } from './perfil-usuario/perfil-usuario.component';
import { PerfilPermissoesComponent } from './perfil-permissoes/perfil-permissoes.component';
import { PerfilUsuarioEditComponent } from './perfil-usuario-edit/perfil-usuario-edit.component';
import { ProdutoEntradaEditComponent } from './produto-entrada-edit/produto-entrada-edit.component';
import { ProdutoSaidaEditComponent } from './produto-saida-edit/produto-saida-edit.component';
import { RelatorioVeiculosComponent } from './relatorio-veiculos/relatorio-veiculos.component';
import { RelatorioCondutoresComponent } from './relatorio-condutores/relatorio-condutores.component';
import { UnidadesComponent } from './unidades/unidades.component';
import { UnidadesEditComponent } from './unidades-edit/unidades-edit.component';
import { AgenciasComponent } from './agencias/agencias.component';
import { AgenciasEditComponent } from './agencias-edit/agencias-edit.component';
import { ChecklistVerComponent } from './checklist-ver/checklist-ver.component';
import { PrintLayoutComponent } from './print-layout/print-layout.component';
import { ChecklistPrintComponent } from './print/checklist-print/checklist-print.component';
import { ChecklistMotoComponent } from './checklist-moto/checklist-moto.component';
import { ChecklistMotoEditComponent } from './checklist-moto-edit/checklist-moto-edit.component';
import { ChecklistMotoVerComponent } from './checklist-moto-ver/checklist-moto-ver.component';
import { CheckmotoprintComponent } from './print/checkmotoprint/checkmotoprint.component';
import { CheckambulanciaprintComponent } from './print/checkambulanciaprint/checkambulanciaprint.component';
import { TrocarSenhaComponent } from './trocar-senha/trocar-senha.component';

import { EqualValidatorDirective } from './validators/equal-validator.directive';
import { EsqueciSenhaComponent } from './esqueci-senha/esqueci-senha.component';
import { CalibragemPneusComponent } from './calibragem-pneus/calibragem-pneus.component';
import { CalibragemPneusEditComponent } from './calibragem-pneus-edit/calibragem-pneus-edit.component';
import { MilimetragemPneusComponent } from './milimetragem-pneus/milimetragem-pneus.component';
import { MilimetragemPneusEditComponent } from './milimetragem-pneus-edit/milimetragem-pneus-edit.component';
import { EmbarqueEquipeComponent } from './embarque-equipe/embarque-equipe.component';
import { EmbarqueEquipeEditComponent } from './embarque-equipe-edit/embarque-equipe-edit.component';
import { VeiculosprintComponent } from './print/relatorio/veiculosprint/veiculosprint.component';
import { CondutoresprintComponent } from './print/relatorio/condutoresprint/condutoresprint.component';
import { RelatorioChecklistAmbulanciaComponent } from './relatorio-checklist-ambulancia/relatorio-checklist-ambulancia.component';
import { CalibragemPneusVerComponent } from './calibragem-pneus-ver/calibragem-pneus-ver.component';
import { MilimetragemPneusVerComponent } from './milimetragem-pneus-ver/milimetragem-pneus-ver.component';
import { OrdemServicoComponent } from './ordem-servico/ordem-servico.component';
import { OrdemServicoEditComponent } from './ordem-servico-edit/ordem-servico-edit.component';
import { OficinasComponent } from './oficinas/oficinas.component';
import { OficinasEditComponent } from './oficinas-edit/oficinas-edit.component';
import { PecasComponent } from './pecas/pecas.component';
import { PecasEditComponent } from './pecas-edit/pecas-edit.component';
import { TipoServicoComponent } from './tipo-servico/tipo-servico.component';
import { TipoServicoEditComponent } from './tipo-servico-edit/tipo-servico-edit.component';
import { SeguradoraComponent } from './seguradora/seguradora.component';
import { SeguradoraEditComponent } from './seguradora-edit/seguradora-edit.component';
import { CorretoraComponent } from './corretora/corretora.component';
import { CorretoraEditComponent } from './corretora-edit/corretora-edit.component';
import { SinistroComponent } from './sinistro/sinistro.component';
import { SinistroEditComponent } from './sinistro-edit/sinistro-edit.component';
import { TimeValidatorDirective } from './validators/time-validator.directive';
import { DocumentosComponent } from './documentos/documentos.component';
import { DocumentosEditComponent } from './documentos-edit/documentos-edit.component';
import { NormaComponent } from './norma/norma.component';
import { NormaEditComponent } from './norma-edit/norma-edit.component';
import { MochilaComponent } from './mochila/mochila.component';
import { MochilaEditComponent } from './mochila-edit/mochila-edit.component';
import { TipoMochilaComponent } from './tipo-mochila/tipo-mochila.component';
import { TipoMochilaEditComponent } from './tipo-mochila-edit/tipo-mochila-edit.component';
import { ChecklistMochilaComponent } from './checklist-mochila/checklist-mochila.component';
import { ChecklistMochilaEditComponent } from './checklist-mochila-edit/checklist-mochila-edit.component';
import { ChecklistMochilaVerComponent } from './checklist-mochila-ver/checklist-mochila-ver.component';
import { CheckmochilaprintComponent } from './print/checkmochilaprint/checkmochilaprint.component';
import { ProdutoSaldoComponent } from './produto-saldo/produto-saldo.component';
import { FornecedoresComponent } from './fornecedores/fornecedores.component';
import { FornecedoresEditComponent } from './fornecedores-edit/fornecedores-edit.component';


import { HttpClientModule } from '@angular/common/http';


registerLocaleData(localePt);

const appRoutes: Routes = [
	{ path: '', redirectTo: '/login', pathMatch: 'full' },
	{ path: 'login', component: LoginComponent },
	{ path: 'esqueciasenha', component: EsqueciSenhaComponent },
	{
		path: 'home', component: HomeComponent, canActivate: [AuthGuard], children: [
			{ path: '', redirectTo: '/home/dashboardfrotas', pathMatch: 'full', canActivate: [CondutorGuard] },
			{ path: 'dashboard', component: DashboardComponent, canActivate: [CondutorGuard] },
			{ path: 'dashboardfrotas', component: DashboardFrotasComponent, canActivate: [CondutorGuard, MecanicoGuard] },
			{ path: 'dashboardoperacao', component: DashboardOperacaoComponent, canActivate: [CondutorGuard] },

			{ path: 'usuarios', component: UsuariosComponent,  canActivate: [AuthGuard] },
			{ path: 'veiculos', component: VeiculosComponent, canActivate: [CondutorGuard]},

			{ path: 'usuariosfiltro/:id', component: UsuariosComponent },
			{ path: 'usuarios/create', component: UsuariosEditComponent },
			{ path: 'usuarios/edit/:id', component: UsuariosEditComponent },
			{ path: 'usuarios/edit/:id/:visualizar', component: UsuariosEditComponent },

			{ path: 'eventos', component: AlertasComponent },


			{ path: 'checklist', component: ChecklistComponent },
			{ path: 'checklistfiltro/:id', component: ChecklistComponent },
			{ path: 'checklist/create', component: ChecklistEditComponent },
			{ path: 'checklist/edit/:id', component: ChecklistEditComponent },
			{ path: 'checklist/ver/:id', component: ChecklistVerComponent },

			{ path: 'checkmoto', component: ChecklistMotoComponent },
			{ path: 'checkmoto/create', component: ChecklistMotoEditComponent },
			{ path: 'checkmoto/edit/:id', component: ChecklistMotoEditComponent },
			{ path: 'checkmoto/ver/:id', component: ChecklistMotoVerComponent },
			{ path: 'checkmotofiltro/:id', component: ChecklistMotoComponent },

			
			{ path: 'veiculos/create', component: VeiculosEditComponent, canActivate: [CondutorGuard] },
			{ path: 'veiculos/edit/:id', component: VeiculosEditComponent, canActivate: [CondutorGuard] },
			{ path: 'veiculos/edit/:id/:visualizar', component: VeiculosEditComponent, canActivate: [CondutorGuard] },

			{ path: 'marcasveiculo', component: MarcaVeiculoComponent, canActivate: [AuthGuard] },
			{ path: 'marcasveiculo/create', component: MarcaVeiculoEditComponent, canActivate: [AuthGuard] },
			{ path: 'marcasveiculo/edit/:id', component: MarcaVeiculoEditComponent, canActivate: [AuthGuard] },
			{ path: 'modelosveiculo', component: ModeloVeiculoComponent, canActivate: [AuthGuard] },
			{ path: 'modelosveiculo/create', component: ModeloVeiculoEditComponent, canActivate: [AuthGuard] },
			{ path: 'modelosveiculo/edit/:id', component: ModeloVeiculoEditComponent, canActivate: [AuthGuard] },
			{ path: 'modelosveiculo/manutencao/:id', component: ModeloVeiculoManutencaoComponent, canActivate: [AuthGuard] },
			{ path: 'tiposveiculo', component: TipoVeiculoComponent, canActivate: [AuthGuard] },
			{ path: 'tiposveiculo/create', component: TipoVeiculoEditComponent, canActivate: [AuthGuard] },
			{ path: 'tiposveiculo/edit/:id', component: TipoVeiculoEditComponent, canActivate: [AuthGuard] },
			{ path: 'especialidadesveiculo', component: EspecialidadeVeiculoComponent, canActivate: [AuthGuard] },
			{ path: 'especialidadesveiculo/create', component: EspecialidadeVeiculoEditComponent, canActivate: [AuthGuard] },
			{ path: 'especialidadesveiculo/edit/:id', component: EspecialidadeVeiculoEditComponent, canActivate: [AuthGuard] },
			{ path: 'coresveiculo', component: CoresVeiculoComponent, canActivate: [AuthGuard] },
			{ path: 'coresveiculo/create', component: CoresVeiculoEditComponent, canActivate: [AuthGuard] },
			{ path: 'coresveiculo/edit/:id', component: CoresVeiculoEditComponent, canActivate: [AuthGuard] },
			{ path: 'motivosindisponibilidade', component: MotivosIndisponibilidadeComponent, canActivate: [AuthGuard] },
			{ path: 'motivosindisponibilidade/create', component: MotivosIndisponibilidadeEditComponent, canActivate: [AuthGuard] },
			{ path: 'motivosindisponibilidade/edit/:id', component: MotivosIndisponibilidadeEditComponent, canActivate: [AuthGuard] },

			{ path: 'multas', component: MultasComponent, canActivate: [CondutorGuard] },
			{ path: 'multasfiltro/:id', component: MultasComponent, canActivate: [CondutorGuard] },
			{ path: 'multas/create', component: MultasEditComponent, canActivate: [CondutorGuard] },
			{ path: 'multas/edit/:id', component: MultasEditComponent, canActivate: [CondutorGuard] },

			{ path: 'tiposmulta', component: TiposMultaComponent, canActivate: [AuthGuard] },
			{ path: 'tiposmulta/create', component: TiposMultaEditComponent, canActivate: [AuthGuard] },
			{ path: 'tiposmulta/edit/:id', component: TiposMultaEditComponent, canActivate: [AuthGuard] },

			{ path: 'despesas', component: DespesasComponent, canActivate: [CondutorGuard] },
			{ path: 'despesas/create', component: DespesasEditComponent, canActivate: [CondutorGuard] },
			{ path: 'despesas/edit/:id', component: DespesasEditComponent, canActivate: [CondutorGuard] },
			{ path: 'despesaplanejamentos', component: DespesaPlanejamentosComponent, canActivate: [CondutorGuard] },
			{ path: 'despesaplanejamentos/create', component: DespesaPlanejamentosEditComponent, canActivate: [CondutorGuard] },
			{ path: 'despesaplanejamentos/edit/:id', component: DespesaPlanejamentosEditComponent, canActivate: [CondutorGuard] },
			{ path: 'unidadesmedida', component: UnidadesMedidaComponent, canActivate: [CondutorGuard] },
			{ path: 'unidadesmedida/create', component: UnidadesMedidaEditComponent, canActivate: [CondutorGuard] },
			{ path: 'unidadesmedida/edit/:id', component: UnidadesMedidaEditComponent, canActivate: [CondutorGuard] },
			{ path: 'tiposdespesa', component: TiposDespesaComponent, canActivate: [AuthGuard] },
			{ path: 'tiposdespesa/create', component: TiposDespesaEditComponent, canActivate: [AuthGuard] },
			{ path: 'tiposdespesa/edit/:id', component: TiposDespesaEditComponent, canActivate: [AuthGuard] },
			{ path: 'gruposdespesa', component: GruposDespesaComponent, canActivate: [AuthGuard] },
			{ path: 'gruposdespesa/create', component: GruposDespesaEditComponent, canActivate: [AuthGuard] },
			{ path: 'gruposdespesa/edit/:id', component: GruposDespesaEditComponent, canActivate: [AuthGuard] },

			{ path: 'manutencao', component: ManutencaoComponent, canActivate: [CondutorGuard] },
			{ path: 'manutencaofiltro/:id', component: ManutencaoComponent, canActivate: [CondutorGuard] },
			{ path: 'manutencao/create', component: ManutencaoEditComponent, canActivate: [CondutorGuard] },
			{ path: 'manutencao/edit/:id', component: ManutencaoEditComponent, canActivate: [CondutorGuard] },
			{ path: 'combustivel', component: CombustivelComponent, canActivate: [CondutorGuard] },
			{ path: 'combustivelfiltro/:id', component: CombustivelComponent, canActivate: [CondutorGuard] },
			{ path: 'combustivel/create', component: CombustivelEditComponent, canActivate: [CondutorGuard] },
			{ path: 'combustivel/edit/:id', component: CombustivelEditComponent, canActivate: [CondutorGuard] },
			{ path: 'ipva', component: IpvaComponent, canActivate: [CondutorGuard] },
			{ path: 'ipvafiltro/:id', component: IpvaComponent, canActivate: [CondutorGuard] },
			{ path: 'ipva/create', component: IpvaEditComponent, canActivate: [CondutorGuard] },
			{ path: 'ipva/edit/:id', component: IpvaEditComponent, canActivate: [CondutorGuard] },
			{ path: 'seguro', component: SeguroComponent, canActivate: [CondutorGuard] },
			{ path: 'segurofiltro/:id', component: SeguroComponent, canActivate: [CondutorGuard] },
			{ path: 'seguro/create', component: SeguroEditComponent, canActivate: [CondutorGuard] },
			{ path: 'seguro/edit/:id', component: SeguroEditComponent, canActivate: [CondutorGuard] },

			{ path: 'intervencoes', component: IntervencoesComponent, canActivate: [CondutorGuard] },
			{ path: 'intervencoes-veiculo/:id', component: IntervencoesVeiculoComponent, canActivate: [CondutorGuard] },

			{ path: 'postos', component: PostoComponent, canActivate: [AuthGuard] },
			{ path: 'postos/create', component: PostoEditComponent, canActivate: [AuthGuard] },
			{ path: 'postos/edit/:id', component: PostoEditComponent, canActivate: [AuthGuard] },

			{ path: 'categoriadespesa', component: CategoriasDesepesaComponent, canActivate: [AuthGuard] },
			{ path: 'categoriadespesa/create', component: CategoriasDesepesaEditComponent, canActivate: [AuthGuard] },
			{ path: 'categoriadespesa/edit/:id', component: CategoriasDesepesaEditComponent, canActivate: [AuthGuard] },

			{ path: 'profissionais', component: ProfissionaisComponent, canActivate: [AuthGuard] },
			{ path: 'profissionaisfiltro/:id', component: ProfissionaisComponent, canActivate: [AuthGuard] },
			{ path: 'profissionais/create', component: ProfissionaisEditComponent, canActivate: [AuthGuard] },
			{ path: 'profissionais/edit/:id', component: ProfissionaisEditComponent, canActivate: [AuthGuard] },

			{ path: 'ranking-condutores', component: RankingCondutoresComponent, canActivate: [CondutorGuard] },

			{ path: 'estoque', component: EstoqueComponent },
			{ path: 'estoquefiltro/:id', component: EstoqueComponent },
			{ path: 'estoque/create', component: EstoqueEditComponent },
			{ path: 'estoque/edit/:id', component: EstoqueEditComponent },
			{ path: 'estoque/ver/:id', component: EstoqueEditComponent },

			{ path: 'produto-entrada', component: ProdutoEntradaComponent },
			{ path: 'produto-entradafiltro/:id', component: ProdutoEntradaComponent },
			{ path: 'produto-entrada/create', component: ProdutoEntradaEditComponent },
			{ path: 'produto-entrada/edit/:id', component: ProdutoEntradaEditComponent },
			{ path: 'produto-entrada/ver/:id', component: ProdutoEntradaEditComponent },

			{ path: 'produto-saida', component: ProdutoSaidaComponent },
			{ path: 'produto-saidafiltro/:id', component: ProdutoSaidaComponent },
			{ path: 'produto-saida/create', component: ProdutoSaidaEditComponent },
			{ path: 'produto-saida/edit/:id', component: ProdutoSaidaEditComponent },
			{ path: 'produto-saida/ver/:id', component: ProdutoSaidaEditComponent },

			{ path: 'produto-saldo', component: ProdutoSaldoComponent },

			{ path: 'fornecedores', component: FornecedoresComponent },
			{ path: 'fornecedores/create', component: FornecedoresEditComponent },
			{ path: 'fornecedores/edit/:id', component: FornecedoresEditComponent },
			{ path: 'fornecedores/ver/:id', component: FornecedoresEditComponent },

			{ path: 'grupos-produto', component: GruposProdutoComponent },
			{ path: 'grupos-produto/create', component: GruposProdutoEditComponent },
			{ path: 'grupos-produto/edit/:id', component: GruposProdutoEditComponent },
			{ path: 'grupos-produto/ver/:id', component: GruposProdutoEditComponent },

			{ path: 'perfil-usuario', component: PerfilUsuarioComponent },
			{ path: 'perfil-usuario/create', component: PerfilUsuarioEditComponent },
			{ path: 'perfil-usuario/edit/:id', component: PerfilUsuarioEditComponent },

			{ path: 'perfil-permissoes', component: PerfilPermissoesComponent },
			{ path: 'perfil-permissoes/create', component: PerfilPermissoesComponent },
			{ path: 'perfil-permissoes/edit/:id', component: PerfilPermissoesComponent },

			{ path: 'relatorio-veiculos', component: RelatorioVeiculosComponent },
			{ path: 'relatorio-condutores', component: RelatorioCondutoresComponent },
			{ path: 'relatorio-checklist-ambulancias', component: RelatorioChecklistAmbulanciaComponent },

			{ path: 'agencias', component: AgenciasComponent },
			{ path: 'agencias/create', component: AgenciasEditComponent },
			{ path: 'agencias/edit/:id', component: AgenciasEditComponent },

			{ path: 'unidades', component: UnidadesComponent },
			{ path: 'unidades/create', component: UnidadesEditComponent },
			{ path: 'unidades/edit/:id', component: UnidadesEditComponent },

			{ path: 'ordemservico', component: OrdemServicoComponent },
			{ path: 'ordemservico/create', component: OrdemServicoEditComponent },
			{ path: 'ordemservico/edit/:id', component: OrdemServicoEditComponent },

			{ path: 'calibragempneus', component: CalibragemPneusComponent },
			{ path: 'calibragempneus/create', component: CalibragemPneusEditComponent },
			{ path: 'calibragempneus/edit/:id', component: CalibragemPneusEditComponent },
			{ path: 'calibragempneus/ver/:id', component: CalibragemPneusVerComponent },
			{ path: 'calibragempneusfiltro/:id', component: CalibragemPneusComponent },

			{ path: 'milimetragempneus', component: MilimetragemPneusComponent },
			{ path: 'milimetragempneus/create', component: MilimetragemPneusEditComponent },
			{ path: 'milimetragempneus/edit/:id', component: MilimetragemPneusEditComponent },
			{ path: 'milimetragempneus/ver/:id', component: MilimetragemPneusVerComponent },
			{ path: 'milimetragempneusfiltro/:id', component: MilimetragemPneusComponent },

			{ path: 'embarqueequipe', component: EmbarqueEquipeComponent },			
			{ path: 'embarqueequipe/create', component: EmbarqueEquipeEditComponent },
			{ path: 'embarqueequipe/edit/:id', component: EmbarqueEquipeEditComponent },
			{ path: 'embarqueequipe/edit/:id/:visualizar', component: EmbarqueEquipeEditComponent },
			{ path: 'embarqueequipefiltro/:id', component: EmbarqueEquipeComponent },

			{ path: 'oficinas', component: OficinasComponent },
			{ path: 'oficinas/create', component: OficinasEditComponent },
			{ path: 'oficinas/edit/:id', component: OficinasEditComponent },

			{ path: 'pecas', component: PecasComponent },
			{ path: 'pecas/create', component: PecasEditComponent },
			{ path: 'pecas/edit/:id', component: PecasEditComponent },

			{ path: 'tiposervico', component: TipoServicoComponent },
			{ path: 'tiposervico/create', component: TipoServicoEditComponent },
			{ path: 'tiposervico/edit/:id', component: TipoServicoEditComponent },

			{ path: 'seguradora', component: SeguradoraComponent },
			{ path: 'seguradora/create', component: SeguradoraEditComponent },
			{ path: 'seguradora/edit/:id', component: SeguradoraEditComponent },

			{ path: 'corretora', component: CorretoraComponent },
			{ path: 'corretora/create', component: CorretoraEditComponent },
			{ path: 'corretora/edit/:id', component: CorretoraEditComponent },

			{ path: 'sinistro', component: SinistroComponent },
			{ path: 'sinistro/create', component: SinistroEditComponent },
			{ path: 'sinistro/edit/:id', component: SinistroEditComponent },

			{ path: 'formularios', component: DocumentosComponent },
			{ path: 'formularios/create', component: DocumentosEditComponent },
			{ path: 'formularios/edit/:id', component: DocumentosEditComponent },
			
			{ path: 'norma', component: NormaComponent },
			{ path: 'norma/create', component: NormaEditComponent },
			{ path: 'norma/edit/:id', component: NormaEditComponent },

			{ path: 'mochila', component: MochilaComponent },
			{ path: 'mochila/create', component: MochilaEditComponent },
			{ path: 'mochila/edit/:id', component: MochilaEditComponent },
			{ path: 'mochila/ver/:id', component: MochilaEditComponent },

			{ path: 'tipomochila', component: TipoMochilaComponent },
			{ path: 'tipomochila/create', component: TipoMochilaEditComponent },
			{ path: 'tipomochila/edit/:id', component: TipoMochilaEditComponent },

			{ path: 'checkmochila', component: ChecklistMochilaComponent },
			{ path: 'checkmochila/create', component: ChecklistMochilaEditComponent },
			{ path: 'checkmochila/edit/:id', component: ChecklistMochilaEditComponent },
			{ path: 'checkmochila/ver/:id', component: ChecklistMochilaVerComponent },
			{ path: 'checkmochilafiltro/:id', component: ChecklistMochilaComponent },
			{ path: 'trocarsenha', component: TrocarSenhaComponent },

			//Imprimir CheckList - Ambulancia'
			{ path: 'checkambulanciaprint/:id', component: CheckambulanciaprintComponent },
			{ path: 'checkmotoprint/:id', component: CheckmotoprintComponent },
			{ path: 'checkmochilaprint/:id', component: CheckmochilaprintComponent },

			{ path: 'forbidden', component: NotFoundComponent },
			{ path: '**', component: NotFoundComponent }
		]
	},
	{
		path: 'print',
		outlet: 'print',
		component: PrintLayoutComponent,
		children: [
			{ path: 'checklist/:id', component: ChecklistPrintComponent },
			//{ path: 'checkambulancia/:id', component: CheckambulanciaprintComponent },
			//{ path: 'checkmoto/:id', component: CheckmotoprintComponent },
			//{ path: 'checkmochila/:id', component: CheckmochilaprintComponent },
			{ path: 'relatorio/veiculos/:id', component: VeiculosprintComponent },
			{ path: 'relatorio/condutores/:id', component: CondutoresprintComponent }
		]
	},
	{ path: '**', component: NotFoundComponent }
];


@NgModule({
	declarations: [
		FilterPipe,
		FiltroMultaPipe,
		AppComponent,
		LoginComponent,
		DashboardComponent,
		TopBarComponent,
		MenuLateralComponent,
		FooterComponent,
		HomeComponent,
		NotFoundComponent,
		UsuariosComponent,
		PaginationComponent,
		UsuariosEditComponent,
		MultasComponent,
		MultasEditComponent,
		DespesasComponent,
		DespesasEditComponent,
		TiposMultaComponent,
		TiposMultaEditComponent,
		TiposDespesaEditComponent,
		TiposDespesaComponent,
		GruposDespesaComponent,
		GruposDespesaEditComponent,
		UnidadesMedidaComponent,
		UnidadesMedidaEditComponent,
		DespesaPlanejamentosComponent,
		DespesaPlanejamentosEditComponent,
		VeiculosComponent,
		VeiculosEditComponent,
		TipoVeiculoComponent,
		TipoVeiculoEditComponent,
		EspecialidadeVeiculoEditComponent,
		EspecialidadeVeiculoComponent,
		MarcaVeiculoComponent,
		MarcaVeiculoEditComponent,
		ModeloVeiculoComponent,
		ModeloVeiculoEditComponent,
		ManutencaoComponent,
		CombustivelComponent,
		IpvaComponent,
		SeguroComponent,
		SeguroEditComponent,
		ManutencaoEditComponent,
		CombustivelEditComponent,
		IpvaEditComponent,
		MotivosIndisponibilidadeComponent,
		MotivosIndisponibilidadeEditComponent,
		AlertasComponent,
		CoresVeiculoComponent,
		CoresVeiculoEditComponent,
		ChecklistComponent,
		DashboardFrotasComponent,
		DashboardOperacaoComponent,
		ModeloVeiculoManutencaoComponent,
		IntervencoesComponent,
		PostoComponent,
		PostoEditComponent,
		CategoriasDesepesaComponent,
		CategoriasDesepesaEditComponent,
		FiltroManutencoesPipe,
		ChecklistEditComponent,
		FiltroChecklistPipe,
		FiltroPipe,
		ProfissionaisComponent,
		ProfissionaisEditComponent,
		IntervencoesVeiculoComponent,
		UsuarioEmailComponent,
		RankingCondutoresComponent,
		TelefonePipe,
		CepPipe,
		EstoqueComponent,
		EstoqueEditComponent,
		ProdutoEntradaComponent,
		ProdutoSaidaComponent,
		GruposProdutoComponent,
		PerfilUsuarioComponent,
		PerfilUsuarioEditComponent,
		PerfilPermissoesComponent,
		GruposProdutoEditComponent,
		ProdutoEntradaEditComponent,
		ProdutoSaidaEditComponent,
		RelatorioVeiculosComponent,
		RelatorioCondutoresComponent,
		UnidadesComponent,
		UnidadesEditComponent,
		AgenciasComponent,
		AgenciasEditComponent,
		ChecklistVerComponent,
		PrintLayoutComponent,
		ChecklistPrintComponent,
		ChecklistMotoComponent,
		ChecklistMotoEditComponent,
		ChecklistMotoVerComponent,
		CheckmotoprintComponent,
		CheckambulanciaprintComponent,
		TrocarSenhaComponent,
		EqualValidatorDirective,
		EsqueciSenhaComponent,
		CalibragemPneusComponent,
		CalibragemPneusEditComponent,
		MilimetragemPneusComponent,
		MilimetragemPneusEditComponent,
		EmbarqueEquipeComponent,
		EmbarqueEquipeEditComponent,
		VeiculosprintComponent,
		CondutoresprintComponent,
		RelatorioChecklistAmbulanciaComponent,
		CalibragemPneusVerComponent,
		MilimetragemPneusVerComponent,
		OrdemServicoComponent,
		OrdemServicoEditComponent,
		OficinasComponent,
		OficinasEditComponent,
		PecasComponent,
		PecasEditComponent,
		TipoServicoComponent,
		TipoServicoEditComponent,
		SeguradoraComponent,
		SeguradoraEditComponent,
		CorretoraComponent,
		CorretoraEditComponent,
		SinistroComponent,
		SinistroEditComponent,
		TimeValidatorDirective,
		DocumentosComponent,
		DocumentosEditComponent,
		NormaComponent,
		NormaEditComponent,
		MochilaComponent,
		MochilaEditComponent,
		TipoMochilaComponent,
		TipoMochilaEditComponent,
		ChecklistMochilaComponent,
		ChecklistMochilaEditComponent,
		ChecklistMochilaVerComponent,
		CheckmochilaprintComponent,
		ProdutoSaldoComponent,
		FornecedoresComponent,
		FornecedoresEditComponent,
	],
	imports: [
		BrowserAnimationsModule,
		BrowserModule,
		CurrencyMaskModule,
		FormsModule,
		HttpModule,
		NgSelectModule,
		ReactiveFormsModule,
		SlickCarouselModule,
		FontAwesomeModule,
		SweetAlert2Module.forRoot(),
		NgxMaskModule.forRoot(),
		RouterModule.forRoot(
			appRoutes,
			//{ enableTracing: true } // <-- debugging purposes only
		),
		WebStorageModule,
		HttpClientModule,
	],
	exports: [RouterModule],
	providers: [
		AuthGuard,
		{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
		//{ provide: LocationStrategy, useClass: HashLocationStrategy },
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
